<p-dialog header="" [(visible)]="visible" [modal]="true" [closable]="false">
  <div class="modal-header">
    <button
      *ngIf="isSelectingSize"
      type="button"
      class="back-btn"
      (click)="goBack()"
      aria-label="Back to ordnance list"
      i18n-aria-label="@@backToListAriaLabel">
      <i class="ri-arrow-left-line"></i>
    </button>

    <h2 i18n="@@possibleIdentificationTitle">Possible Identification</h2>

  </div>
  <ng-container *ngIf="!isSelectingSize">

    <p i18n="@@selectItemInstruction">
      Select the item that best matches what you found.
    </p>

    <div *ngFor="let group of visibleGroups" class="ord-group">
      <h3>{{ group.name }}</h3>
      <div class="ordnances">
        <button
          *ngFor="let item of group.items"
          class="ordnance"
          (click)="onSelect(item.name)">

          <img *ngIf="item.image" [src]="item.image" 
            i18n-alt="@@ordnance.imageAlt"
            alt="ordnance" />
          <span *ngIf="!item.image" [innerText]="item.name"></span>
        </button>
      </div>
    </div>
    <div class="actions">
      <button
        pButton
        label="Cancel"
        i18n-label="@@cancelButton"
        class="p-button-text"
        type="button"
        (click)="onCancel()">
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="isSelectingSize && selectedOrdnance">

    <p i18n="@@selectSizeInstruction">
      Choose the size that best represents the item found.
    </p>

    <div class="size-options">
      <button
        *ngFor="let size of sizeOptions"
        class="size-option"
        [class.selected]="selectedSizeKey === size.key"
        (click)="onSizeSelect(size.key)">

        <img [src]="selectedOrdnance.image" 
          i18n-alt="@@ordnance.imageAlt"
          alt="ordnance" 
          class="size-img" />
        <div class="size-info">

          <div class="size-label">
            {{ size.key.split("_")[size.key.split("_").length - 1] | titlecase }}
          </div>

          <div class="size-desc">{{ size.size }}</div>
        </div>
      </button>
    </div>
    <div class="actions">
      <button
        pButton
        label="Cancel"
        i18n-label="@@cancelButton"
        class="p-button-text"
        type="button"
        (click)="onCancel()">
      </button>

      <button
        pButton
        label="Save"
        i18n-label="@@saveButton"
        class="p-button-primary"
        [disabled]="!selectedSizeKey"
        (click)="onSave()">
      </button>

    </div>
  </ng-container>
</p-dialog>